import { httpsCallable } from 'firebase/functions';
import { functions } from '../../config';
import type {
  ListAuditLogsParams,
  ListAuditLogsResult,
  RequestAuditLogColdExportParams,
  RequestAuditLogColdExportResult,
} from '../../../../types/security';

interface ListAuditLogsRawResponse {
  success: boolean;
  data: ListAuditLogsResult;
}

interface RequestAuditLogColdExportRawResponse {
  success: boolean;
  data: RequestAuditLogColdExportResult;
}

/**
 * 監査ログ閲覧（#2985）。同社 companyAdmin または運営スタッフのみ。
 * 期間 / 操作者メール / アクション / IP で絞り込み、cursor でページ送りする。
 */
export const listAuditLogs = async (params: ListAuditLogsParams): Promise<ListAuditLogsResult> => {
  const callable = httpsCallable<ListAuditLogsParams, ListAuditLogsRawResponse>(
    functions,
    'listAuditLogs',
  );
  const result = await callable(params);
  return result.data.data;
};

/**
 * 監査ログ コールド層エクスポート依頼（#2985）。同社 companyAdmin または運営 admin のみ。
 * 直近 3 ヶ月より前のログを非同期で CSV 抽出し、署名付き URL（24 時間有効）を
 * 依頼者のメールアドレスへ送付する。
 */
export const requestAuditLogColdExport = async (
  params: RequestAuditLogColdExportParams,
): Promise<RequestAuditLogColdExportResult> => {
  const callable = httpsCallable<
    RequestAuditLogColdExportParams,
    RequestAuditLogColdExportRawResponse
  >(functions, 'requestAuditLogColdExport');
  const result = await callable(params);
  return result.data.data;
};
